import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { addNotifications } from 'store/modules/app/notifications/actions';
import { Types } from './types';

// ACTIONS
import {
	IRequestDareGuia,
	IRequestDareCpf,
	consultarDareSuccess,
	consultarDareClear,
} from './actions';

interface IRequestPesquisaDareGuia {
	numeroControleGuiaMae: string;
	orgao: number;
}

interface IRequestPesquisaDareCpf {
	cpf: string;
	orgao: number;
}

function* consultarDareGuiaRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: IRequestDareGuia } =
		request;

	yield put(consultarDareClear());

	const params: IRequestPesquisaDareGuia = {
		numeroControleGuiaMae: payload.dare,
		orgao: payload.orgao,
	};

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'dare',
		params,
	);

	if (response.status === 200) {
		const responseArray = Array.isArray(response.data)
			? response.data
			: [response.data];
		yield put(consultarDareSuccess(response.status, responseArray));
	} else {
		yield put(consultarDareSuccess(204, null));
	}
}

function* consultarDareCpfRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: IRequestDareCpf } =
		request;

	yield put(consultarDareClear());

	const params: IRequestPesquisaDareCpf = {
		cpf: payload.cpf,
		orgao: payload.orgao,
	};

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'dare',
		params,
	);

	if (response.status === 200) {
		yield put(consultarDareSuccess(response.status, response.data));
	} else {
		addNotifications({ errors: ['Nenhuma DARE encontrada.'] });
		yield put(consultarDareSuccess(204, null));
	}
}

export default all([
	takeLatest(Types.CONSULTAR_DARE_GUIA_REQUEST, consultarDareGuiaRequest),
	takeLatest(Types.CONSULTAR_DARE_CPF_REQUEST, consultarDareCpfRequest),
]);
